const discount = {
  computed: {
    calculateDiscount() {
      return parseInt(100 - (this.price / this.lastPrice) * 100);
    },
  },
};

export default discount;
